export const transformFilterKeysToValuesAndLabels = (objArray, dataType) => {
    const mapping = {
        markets: {
            value: 'rmRegionId',
            label: 'rmRegion'
        },
        teams: {
            value: 'rmGroupId',
            label: 'rmGroup'
        },
        rms: {
            value: 'rmId',
            label: 'rmEmployeeId'
        }
    };
    return objArray.reduce(
        (acc, curr) => [
            ...acc,
            {
                value: curr[mapping[dataType]['value']],
                label: curr[mapping[dataType]['label']]
            }
        ],
        []
    );
};

export const generateAllObjectForMarketsTeamsRms = (data) =>
    checkMarketTeamRmArraysNotEmpty(data) &&
    [data].reduce((acc, curr) => {
        const findMarketAllData = curr.rmRegions.find(
            (item) => item.rmRegion === 'All'
        );
        const findTeamAllData = curr.rmGroups.find(
            (item) => item.rmGroup === 'All'
        );
        const findRmAllData = curr.rmList.find(
            (item) => item.rmEmployeeName === 'All'
        );
        return {
            ...acc,
            market: findMarketAllData ? findMarketAllData.rmRegionId : null,
            team: findTeamAllData ? findTeamAllData.rmGroupId : null,
            rm: findRmAllData ? findRmAllData.rmId : null
        };
    }, {});

const checkMarketTeamRmArraysNotEmpty = (data) =>
    data.rmRegions.length > 0 &&
    data.rmGroups.length > 0 &&
    data.rmList.length > 0;

export const findAllDropdownItemsForMarket = (marketData, allData) => {
    return marketData.map((item) => {
        const findLabelViaValue = allData.find(
            (data) => data.value === item.rmRegionId
        );
        const findLabelViaLabel = allData.find(
            (data) => data.label === item.rmRegion
        );
        const findLabel = findLabelViaValue || findLabelViaLabel;
        return {
            label: findLabel.label,
            value: item.rmRegionId
        };
    });
};

export const findAllDropdownItemsForTeam = (teamData, allData) => {
    return teamData.map((item) => ({
        label: allData.find((data) => data.value === item.rmGroupId).label,
        value: item.rmGroupId
    }));
};

export const findAllDropdownItemsForRm = (rmData, allData) => {
    return rmData.map((item) => ({
        label: allData.find((data) => data.value === item.rmId).label,
        value: item.rmId
    }));
};

export const convertDate = (dateString) => {
    const [day, month, year] = dateString.split('/');
    return new Date(+year, +month - 1, +day);
};
